import { useStorageState } from 'react-storage-hooks';

import { CONSTANTS } from '../../core/config/constants';
import { RangeOflong } from '../../generated/model/rangeOflong';

export interface Props {
  defaultSelectedRows: string[];
  defaultSelectedRange: RangeOflong;
}

interface RowsStorage {
  rows: string[];
  range: RangeOflong;
  version: string;
}

const version = CONSTANTS.ROWS_STORAGE.VERSION;

export const useRawReportModalStorage = ({ defaultSelectedRows, defaultSelectedRange }: Props) => {
  const storageKey = CONSTANTS.ROWS_STORAGE.KEY_PREFIX;
  const [rowsStorage, setRowsStorage] = useStorageState<RowsStorage>(
    // don't change sessionStorage to localStorage
    // it's causes browser freezes due to multiple subscribers to the shared storage
    sessionStorage,
    storageKey,
    { rows: defaultSelectedRows, range: defaultSelectedRange, version },
  );
  const onRowsChanged = (rows: string[]) => {
    setRowsStorage({ ...rowsStorage, rows });
  };

  const onRangeChanged = (range: RangeOflong) => {
    setRowsStorage({ ...rowsStorage, range });
  };

  if (rowsStorage.version !== version) {
    setRowsStorage({ rows: defaultSelectedRows, range: defaultSelectedRange, version });
  }

  return {
    selectedRows: rowsStorage.rows,
    selectedRange: rowsStorage.range,
    onRowsChanged,
    onRangeChanged,
  };
};
